//people reducer types
export const LOADING_SETTINGS = "LOADING_SETTINGS";
export const LOAD_SETTINGS = "LOAD_SETTINGS";
export const FETCH_SETTINGS_REQUEST = "FETCH_SETTINGS_REQUEST";
export const FETCH_SETTINGS_REQUEST_SUCCESS = "FETCH_SETTINGS_REQUEST_SUCCESS";
export const SETTINGS_SAVE_REQUEST = "SETTINGS_SAVE_REQUEST";
export const SETTINGS_SAVE_SUCCESS = "SETTINGS_SAVE_SUCCESS";
